import React, { useEffect, useRef, useState } from "react";
import { Button, Checkbox, Col, Collapse, Input, Row, Select, Spin, Typography, message,Grid } from "antd";
import './PreferredTime.css'
import { ArrowLeftOutlined, DownOutlined, EnvironmentOutlined, SearchOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import moment from "moment";
import { genericApiCall, spacerData } from "./CommonApiCallCalender";
import { ColorCode } from "../Common/ColorCode";
import useDebounce from "../Common/useDebounce";
import { filterByNonGpProductId } from "../Common/CommonFunction";
import location from "../../Assets/location.png"
import locationHover from "../../Assets/locationHover.png"
import AppointmentInfo from "../AppointmentInfo/AppointmentInfo";

const { Option } = Select;
const { Panel } = Collapse;
const { Text, Title } = Typography;


const PreferredTime = (props) => {

    const locationPermission = localStorage.getItem('locationPermission')
    // console.log('::::PreferredTime::props:::', props)
    const [selectedSlots, setSelectedSlots] = useState([]);
    // default selected clinic: use props.clinicId if provided, otherwise no pre-selection
    const [selectedClinics, setSelectedClinics] = useState(() => {
        try {
            return props?.clinicId ? [String(props.clinicId)] : [];
        } catch (e) {
            return [];
        }
    });
    const [loading, setloading] = useState(false);
    const [loadingTime, setloadingTime] = useState(false);
    const [selectedClinicsNew, setSelectedClinicsNew] = useState([]);
    const [selectedClinicsStartAndEndTime, setselectedClinicsStartAndEndTime] = useState([]);
    const [messageApi, contextHolder] = message.useMessage();
    const [showPreferredTimeSlot, setshowPreferredTimeSlot] = useState([]);
    const [locationCoords, setlocationCoords] = useState(null);
    const [searchBylocationName, setsearchBylocationName] = useState('');
    const [locationPermissionData, setlocationPermissionData] = useState(locationPermission);
    const [searchBylocationOption, setsearchBylocationOption] = useState([]);
    const [selectedMonth, setselectedMonth] = useState(null);
    const [metaData, setmetaData] = useState(null);
    const debouncedInputValue = useDebounce(selectedClinicsStartAndEndTime, 800);
    const debouncedInputValueData = useDebounce(searchBylocationName, 800);
    const [loadingLocation, setloadingLocation] = useState(false);
     const [isHovered, setIsHovered] = useState(false);
     // when a clinic is pre-selected, buttonActive should be false
     const [buttonActive, setButtonActive] = useState(() => {
        try {
            return props?.clinicId ? false : true;
        } catch (e) {
            return true;
        }
     });
     const [width, setWidth] = useState(0);
    const elementRefs = useRef([]);
    const scrollingRef = useRef(null);
    const elementwidthRef = useRef(null);
     const nextWeekOptions = Array.from({ length: 7 }, (_, i) => {
        const date = dayjs().add(i, 'day');
        return {
            label: date.format("MMM 'DD"),
            value: date.format("YYYY-MM-DD"),
        };
    });
    
      const buttonStyle = {
    width: "181px",
    height: "40px",
    cursor: "pointer",
    backgroundColor: isHovered ? "#008385":"white" , // darker on hover
    color:isHovered ?"#fff ": "#008385",
    fontFamily: "Lato",
    fontWeight: "400",
    fontSize: "16px",
    margin: "auto",
    display: "flex",
    gap: "8px",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "10px",
    transition: "background-color 0.3s ease", // optional: smooth hover
    border:"1px solid #008385"
  };

  useEffect(() => {
      if (props?.check) {
        // console.log('props?.check', props?.check)
        setSelectedClinics([])
        setButtonActive(true)
      }
  },[props?.check])
 
    
      const { useBreakpoint } = Grid;
        const screens = useBreakpoint();

    const timeSlots = [
        "08:00 - 10:00",
        "10:00 - 12:00",
        "12:00 - 14:00",
        "14:00 - 16:00",
        "16:00 - 18:00",
        "18:00 - 20:00",
    ];

    const days = [
        { day: "MON", date: "13" },
        { day: "TUE", date: "14" },
        { day: "WED", date: "15" },
        { day: "THU", date: "16" },
        { day: "FRI", date: "17" },
    ];
    useEffect(() => {
        window.scrollTo(0, 0);
        // restore any selected slots from metaData
        if (props?.metaData?.selectedClinics && props?.metaData?.selectedSlots) { 
            for (let index = 0; index < props?.metaData?.selectedSlots?.length; index++) {
                toggleSlot(`${props?.metaData?.selectedSlots[index]?.date}${props?.metaData?.selectedSlots[index]?.start_time}-${props?.metaData?.selectedSlots[index]?.end_time}`, props?.metaData?.selectedSlots[index]?.info, props?.metaData?.selectedSlots[index]?.date)
            }
        }

        // If metaData provides selectedClinics, normalize them to strings and use that.
        if (props?.metaData?.selectedClinics) {
            try {
                const sc = Array.isArray(props.metaData.selectedClinics)
                    ? props.metaData.selectedClinics.map((s) => String(s))
                    : [String(props.metaData.selectedClinics)];
                setSelectedClinics(sc);
                setButtonActive(false);
            } catch (e) {
                // fallback to props.clinicId if available, otherwise leave empty
                if (props?.clinicId) {
                    setSelectedClinics([String(props.clinicId)]);
                    setButtonActive(false);
                } else {
                    setSelectedClinics([]);
                    setButtonActive(true);
                }
            }
        } else if (props?.clinicId) {
            // if no metaData but clinicId prop exists, ensure it's selected
            setSelectedClinics([String(props.clinicId)]);
            setButtonActive(false);
        } else {
            // no pre-selection
            setSelectedClinics((prev) => (prev && prev.length ? prev : []));
            setButtonActive(true);
        }

    },[])

    useEffect(() => {
    const element = elementwidthRef.current;
    if (!element) return;

    const observer = new ResizeObserver(() => {
      const visibleWidth = element?.getBoundingClientRect().width;
      const contentWidth = element?.scrollWidth;
      setWidth(visibleWidth -50);
    //   console.log('Width changed. Visible:', visibleWidth, 'Content:', contentWidth);
    });
    observer.observe(element);
    return () => observer.disconnect();
    }, [elementwidthRef]);    

    useEffect(() => {
        // console.log('check', showPreferredTimeSlot ,elementRefs?.current ,width ,elementRefs.current.length ,width % 93)
        if (width % 93 >=80 ||width % 93 <=15 ) {
                        elementRefs.current.forEach((ela) => {
                            ela?.scrollTo({
                                left: 33,
                                behavior: 'smooth'
                            });
                                // console.log('ela', ela)
                        });
                    }
                    else{
                        elementRefs.current.forEach((ela) => {
                            ela?.scrollTo({
                                left: 0,
                                behavior: 'smooth'
                            });
                                // console.log('ela', ela)
                        });
                    }
    }, [showPreferredTimeSlot,width]);

    useEffect(() => {
        getAllPreferedTimeSlot(props.showAppoinmentData.clinic.selectedClinics, 1, true)
    }, [props.showAppoinmentData?.clinic?.selectedClinics, selectedMonth])
    useEffect(() => {
        // console.log('::::::useEffect  getAllDataBYApi:::::::', { debouncedInputValue, locationCoords })
        // return
        if (debouncedInputValue) {

            let newPayload = debouncedInputValue.map(({ id, info, ...rest }) => ({ ...rest }))//clinic_id,
            let payload = {
                ...locationCoords,
                data: newPayload,
                "product_category_id": props.showAppoinmentData.clinic?.productCategory?.product_category_id

            }
            if (props.showAppoinmentData.clinic.isReshedula && props.showAppoinmentData.clinic.calenderData) {
                payload = {
                    ...payload,
                    "appointment_id": props.showAppoinmentData.clinic.calenderData.appointment_id ?? 1,
                }

            }
            if (props.showAppoinmentData.clinic?.productCategory?.product_category_id == 1) {
                payload = {
                    ...payload,
                    "duration_id": props.showAppoinmentData?.duration ?? 1,

                }
            }
            if (props.showAppoinmentData.clinic?.productCategory?.product_category_id == 2) {
                payload = {
                    ...payload,
                    "product_id": props.showAppoinmentData.clinic.non_gp_product_id  ||  props.showAppoinmentData?.non_gp_product_id ||  null,

                }
            }
            getAllDataBYApi(payload)
            if (selectedClinics && selectedClinics.length && selectedClinicsStartAndEndTime && selectedClinicsStartAndEndTime.length) {
                let payloadPass = {
                    selectedClinics: selectedClinics,
                    selectedSlots: selectedClinicsStartAndEndTime,
                    type: 'TIME'
                }
                props.callback(payloadPass, 'PreferredTime');
            }
        }

    }, [debouncedInputValue])
    useEffect(() => {
        // console.log('::::::useEffect ClinicBooking  debouncedInputValue:::::::', debouncedInputValueData)
        if (debouncedInputValueData) {
            getAllSearchData(debouncedInputValueData)
        }
    }, [debouncedInputValueData])
    const getAllSearchData = async (payload) => {
        setloadingLocation(false)
        let data = {
            "input": payload
        }

        let csrRoomData; 
        if(props?.data?.isProtected === false ){
            csrRoomData =  await spacerData('get-address', data , null, false)
        }else {
            csrRoomData = await spacerData('get-address', data)
        }
        if (csrRoomData?.data?.data) {
            let tempData = []
            csrRoomData?.data?.data.map(a => {
                tempData.push({
                    value: `${a?.lat}::${a?.lng}`,
                    label: a.address,
                })
            })
            // console.log('get-address', csrRoomData?.data?.data)
            // setshowPreferredTimeSlot(csrRoomData?.data?.data)
            setsearchBylocationOption(tempData)
            setloadingLocation(false)
        }
    }

    const getAllPreferedTimeSlot = async (id, pageNumber = 1, reset) => {
        setloadingTime(true)
        try {
            let data = {}
            if (props.data.clinic.id) {
                data = {
                    ...data,
                }
            }
            // return
            if (props.showAppoinmentData?.clinic?.productCategory?.product_category_id == 2) {
                if (!props.showAppoinmentData?.clinic?.non_gp_product_id) {
                    messageApi.error({
                        type: 'error',
                        content: 'Please select product category first.',
                    });
                }
                data = {
                    ...data,
                    "product_id": Number(props.showAppoinmentData?.clinic?.non_gp_product_id) ||  Number(props.showAppoinmentData?.non_gp_product_id) || null,
                    "product_category_id": props.showAppoinmentData?.clinic?.productCategory?.product_category_id ?? 2,
                }
            }
            if (props.showAppoinmentData.clinic.isReshedula && props.showAppoinmentData.clinic.calenderData) {
                data = {
                    ...data,
                    "appointment_id": props.showAppoinmentData.clinic.calenderData.appointment_id ?? 1,
                }

            }
            if (props.showAppoinmentData?.clinic?.productCategory?.product_category_id == 1) {
                data = {
                    ...data,
                    "duration_id": props.showAppoinmentData?.duration ?? 1,
                    "product_category_id": props.showAppoinmentData?.clinic?.productCategory?.product_category_id ?? 1,
                    ...(props?.showAppoinmentData?.gender !== 'no_preference' && {
                        gender: props?.showAppoinmentData?.gender,
                    }),
                    "languages": [props?.showAppoinmentData?.language ?? 1],
                }
            }
            if (props?.showAppoinmentData?.appointment_id) {
                data = {
                    ...data,
                    appointment_id: props.showAppoinmentData.appointment_id,
                };
            }
            if (selectedMonth) {
                data = {
                    ...data,
                    "month": selectedMonth ?? 1,
                }
            }
            let api = `preferred-time/page/${pageNumber ? pageNumber : 1}`
            let csrRoomData 
            if(props?.data?.isProtected === false ){
                            csrRoomData = await spacerData(api, data, null, false)
            }else {
                            csrRoomData = await spacerData(api, data)
            }
            setmetaData(csrRoomData.data.meta)
            if (csrRoomData?.data?.data) {
                if (reset) {
                    setshowPreferredTimeSlot(csrRoomData?.data?.data)
                } else {
                    setshowPreferredTimeSlot(pre => ({
                        ...pre,
                        ...csrRoomData.data.data
                    }))
                }

            }
        } catch (error) {
        }

        setloadingTime(false)
    }

    const toggleSlot = async (slot, info, date) => {
        // return
        let newTempData, timeSlots
        setSelectedSlots(prev => {
            if (!selectedSlots.includes(slot)) {
                if (prev.length >= 3) {
                    newTempData = prev
                    return prev;
                } else {
                    newTempData = [...prev, slot];
                    return [...prev, slot];
                }
            } else {
                newTempData = prev.filter(item => item !== slot);
                return prev.filter(item => item !== slot); // remove
            }
        });
        let updatedTimeSlots;
        const id = `${date}${info.start_time}`;
        const alreadySelected = selectedClinicsStartAndEndTime.some(item => item.id === id);

        if (!alreadySelected) {
            if (selectedClinicsStartAndEndTime.length >= 3) {
                messageApi.error({ type: 'error', content: 'Max 3 slots allowed.' });
                updatedTimeSlots = selectedClinicsStartAndEndTime;
            } else {
                const newEntry = {
                    id,
                    end_time: info.end_time,
                    start_time: info.start_time,
                    info,
                    clinic_id: info.available_clinics?.map(cid => cid.clinic_id) || [],
                    date
                };
                updatedTimeSlots = [...selectedClinicsStartAndEndTime, newEntry];
            }
        } else {
            updatedTimeSlots = selectedClinicsStartAndEndTime.filter(item => item.id !== id);
        }

            setselectedClinicsStartAndEndTime(updatedTimeSlots);

        // console.log('timeSlots :::', updatedTimeSlots)
        let payloadPass = {
            selectedSlots: updatedTimeSlots,
            date: date,
            info: info,
        }
        if (newTempData && newTempData.length > 0) {
            // console.log('::::::payloadPass :::::::', { payloadPass, selectedClinicsStartAndEndTime })

        }
    }
    const handleClinicChange = (e) => {
        setButtonActive(false)
        const value = e.target.value;
        const checked = e.target.checked;
        let data

        if (checked) {
            if (selectedClinics.length >= 3) {
                messageApi.error({
                    type: 'error',
                    content: 'You can only select up to 3 options.',
                });
                data = selectedClinics;
                return
            } else {
                data = [...selectedClinics, value];
            }
        } else {
            data = selectedClinics.filter(item => item !== value);
        }

        setSelectedClinics(data);
        // console.log('data:', data);

        let payloadPass = {
            selectedClinics: data,
            selectedSlots: selectedClinicsStartAndEndTime,
            // date: date,
            // info: info,
            type: 'TIME'
        }
        // console.log('data:::', payloadPass)
        props.callback(payloadPass, 'PreferredTime');
    };
 

    const checkLocationPermission = () => {
        if (!navigator.geolocation) {
            messageApi.error({
                type: 'error',
                content: 'Geolocation is not supported by this browser.',
            });
            return;
        }

        navigator.permissions
            .query({ name: 'geolocation' })
            .then((result) => {
                if (result.state === 'denied') {
                    messageApi.error({
                        type: 'error',
                        content: 'Location permission is denied. Please enable it in your browser settings and reload the page.',
                    });
                } else {
                    navigator.geolocation.getCurrentPosition(
                        (position) => {
                            getAllDataBYApi({ lat: position.coords.latitude, lng: position.coords.longitude });
                        },
                        (error) => {
                            messageApi.error({
                                type: 'error',
                                content: 'Unable to retrieve location: ' + error.message,
                            });
                        }
                    );
                }
            })
            .catch((err) => {
                messageApi.error({
                    type: 'error',
                    content: 'Could not check location permission: ' + err.message,
                });
            });
    };
    const getAllDataBYApi = async (coords) => {
        setloading(true)
        const today = moment().format("YYYY-MM-DD");
        if (!coords.lat || !coords.lng) {
            setloading(false)
            // return
        }
        let data = coords
        if (props.showAppoinmentData?.clinic?.productCategory?.product_category_id == 2) {
            data = {
                ...data,
                "product_id": Number(props.showAppoinmentData?.clinic.non_gp_product_id) ||  Number(props.showAppoinmentData?.non_gp_product_id) || null,
                "product_category_id": props.showAppoinmentData?.clinic?.productCategory?.product_category_id ?? 2,
            }
        }
        if (props.showAppoinmentData?.clinic?.productCategory?.product_category_id == 1) {
            data = {
                ...data,
                "duration_id": props.showAppoinmentData?.duration ?? 1,
                "product_category_id": props.showAppoinmentData?.clinic?.productCategory?.product_category_id ?? 1,
            }
        }
        if (props.showAppoinmentData?.clinic?.productCategory?.product_category_id == 1 && props.showAppoinmentData?.gender && props.showAppoinmentData?.gender != 'no_preference') {
            data = {
                ...data,
                "gender": props.showAppoinmentData?.gender ?? undefined,
            }
        }
        if (props.showAppoinmentData?.clinic?.productCategory?.product_category_id == 1 && props.showAppoinmentData?.language) {
            let id = props.showAppoinmentData?.language
            if (props.showAppoinmentData?.language && props.showAppoinmentData?.language?.label && props.showAppoinmentData?.language?.label == 'English') {
                id = 1
            }

            data = {
                ...data,
                "languages": [id] ?? undefined,
            }
        }
        if (props?.showAppoinmentData?.appointment_id) {
            data = {
                ...data,
                appointment_id: props.showAppoinmentData.appointment_id,
            };
        }
        let csrRoomData
        if (selectedSlots.length > 0) {
            if(props?.data?.isProtected === false  ){
                      csrRoomData = await genericApiCall('nearby-clinics', data, null, false)
                  }else {
                      csrRoomData = await genericApiCall('nearby-clinics', data)
                  }
        }
        setSelectedClinicsNew(csrRoomData?.data?.data)
        if (csrRoomData?.data?.data?.length==0) {
            messageApi.error({ type: 'error', content: 'Clinics not available for selected slots.' })

        }
        setloading(false)
    }
    const onSelectLocation = (data) => {
        // console.log(':data::onSelectLocation:', debouncedInputValue)
        let newPayload
        if (debouncedInputValue) {
            newPayload = debouncedInputValue?.map(({ id, info, ...rest }) => ({ ...rest }))
        }

        let dataPayload = data.split('::') ?? []
        if (dataPayload && dataPayload.length && dataPayload.length == 2) {
            let payloadNew={ "lat": dataPayload[0], "lng": dataPayload[1] }
            if (newPayload) {
              payloadNew ={
                ...payloadNew,
                 data:newPayload
              }
            }
            getAllDataBYApi(payloadNew)
        }
    }
    const months = Array.from({ length: 12 }, (_, i) => {
        const month = dayjs().add(i, 'month');
        return {
            value: month.format("MM"),  // e.g., "05"
            label: month.format("MMM YY"), // e.g., "May"
        };
    });
    const currentMonthValue = dayjs().format("MM");
    const handleSelect = (value) => {
        setselectedMonth(value)
    }
    const getLoadMoreData = () => {
        // 
        if (metaData && metaData.current_page && metaData.current_page != metaData.last_page) {
            getAllPreferedTimeSlot(null, (1 + parseInt(metaData.current_page)))
        }
    }

    function getProductName(id) {
        let products;
      
        // Try to load from localStorage and parse to object
        const stored = localStorage.getItem('nongroupproductid');
        if (stored) {
          try {
            products = JSON.parse(stored); // parse string to object
          } catch (e) {
            console.error("Invalid JSON in localStorage");
            products = {}; // fallback to empty object on error
          }
        } else {
          // Fallback if nothing in localStorage
          products = {
            201: "Vital",
            202: "Bronze",
            203: "Silver",
            204: "Gold",
            205: "Platinum",
            4: "Vital (15 minutes)",
            5: "Bronze (60 minutes)",
            6: "Gold (90 minutes)",
            7: "Silver (75min)",
            10: "Platinum",
            18: "r888",
            20: "r888178",
            22: "Diamond"
          };
        }
      
        return products[id] || `Product ${id}`;
      }
      


    return (
        <>
        {(props.showAppoinmentData?.oldDataExist &&  !screens.md) ?(
           <hr />
            
        ):""}
        <div style={{ display: 'grid', margin: 'auto',marginTop:props?.showAppoinmentData?.oldDataExist?"30px":"0px" }}>
            {/* <div style={{ display: 'grid', justifyContent: 'center' }}>
                <div style={{ background: "#00838540", padding:screens.md? 10:0,lineHeight:"100%",maxWidth:screens.md?"605px":"100vw",marginTop:screens.md?"50px":"0px" }} className="">
                    <Title style={{ fontSize: "20px",color: '#008385',fontFamily:"lato",fontWeight:"400",height:"44px",lineHeight:"100%",margin:"0px",display:"flex", justifyContent:screens.md?"center":"start",alignItems:"center",paddingLeft:"8px"  }} >{props?.showAppoinmentData?.oldDataExist ? "New" : "My"} booking:</Title>
                </div>
            </div> */}
                <div
                    style={{
                        background: "#00838540",
                        padding: screens.md ? 10 : 0,
                        maxWidth: screens.md ? "605px" : "100vw",
                        width: "100%",  // Ensures it stretches properly inside grid
                        marginTop: screens.md ? "50px" : "0px",
                        marginInline: "auto",  // Centers the div
                    }}
                >
                    <span
                        style={{
                            fontSize: "20px",
                            color: '#008385',
                            fontWeight: "400",
                            height: "32px",
                            margin: "0px",
                            display: "flex",
                            justifyContent: screens.md ? "center" : "start",
                            alignItems: "center",
                            paddingInline: "8px",
                            paddingLeft: screens.md ? "0px" : "8px",  // Ensure left padding only on mobile
                            textAlign: screens.md ? "center" : "left",  // For safety
                            paddingBlock: screens.md ? "0px" : "8px",
                        }}
                    >
                        {props?.showAppoinmentData?.oldDataExist ? "New" : "My"} booking:
                    </span>
                </div>
            <div className="summuryCard" style={{  marginTop:screens.md? 20 :10}}>
            {/* <span style={{ whiteSpace: "pre-line", textAlign: "center", padding:2 }}>
            {
                props?.showAppoinmentData.clinic?.productCategory?.title ||
                props?.showAppoinmentData.clinic?.clinic?.productCategory?.title || ''
            }

            {
                props?.showAppoinmentData.clinic?.productCategory?.product_category_id === 1 &&
                props.data?.durationObjectById?.[props?.showAppoinmentData?.duration] && (
                <>
                    {"\n"}
                    Duration: {props.data.durationObjectById[props.showAppoinmentData.duration].duration} minutes
                    {
                    props?.showAppoinmentData?.gender &&  props?.showAppoinmentData?.gender !== "no_preference"  ? (
                        <>
                        {" | "} Gender: { props.showAppoinmentData.gender.charAt(0).toUpperCase() + props.showAppoinmentData.gender.slice(1) } 
                        </>
                    ) : null
                    }
                    {
                    props?.showAppoinmentData?.selectedLanguage?.label && props?.showAppoinmentData?.selectedLanguage?.label !== "English" ? (
                        <>
                        {" | "} Language: { props?.showAppoinmentData?.selectedLanguage?.label?.charAt(0)?.toUpperCase() + props?.showAppoinmentData?.selectedLanguage?.label?.slice(1) } 
                        </>
                    ) : null
                    }
                </>
                )
            }



                
                {
                    props?.showAppoinmentData.clinic?.productCategory?.product_category_id == 2 && (
                        <>
                       {" \n"} {getProductName(props?.showAppoinmentData?.non_gp_product_id || props?.showAppoinmentData?.clinic?.non_gp_product_id)}
                       </>
                    )
                }
                </span> */}

{/* // Replace the entire span with this: */}
<AppointmentInfo
  productCategory={
    props?.showAppoinmentData?.clinic?.productCategory || 
    props?.showAppoinmentData?.clinic?.clinic?.productCategory
  }
  duration={
    props.data?.durationObjectById?.[props?.showAppoinmentData?.duration]?.duration
  }
  gender={props?.showAppoinmentData?.gender}
  selectedLanguage={props?.showAppoinmentData?.selectedLanguage}
  nonGpProductId={
    getProductName(
      props?.showAppoinmentData?.non_gp_product_id || 
      props?.showAppoinmentData?.clinic?.non_gp_product_id
    )
  }
//   price={100.00} // You'll need to pass the actual price prop if available
/>
                
            </div>
            <div></div>
            <Row gutter={[16, 16]} style={{margin:"0px",rowGap:"0px",marginBottom:"50px"}} >
                {contextHolder}
                <Col  className="paddingRight timePreference" style={{paddingLeft:"0px"}}
                 xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 12 }}
                    lg={{ span: 12 }}
                    xl={{ span: 12 }}
                    xxl={{ span: 12 }}>
                    <div style={{paddingTop:"20px", }} className="widthOfTitle">
                        <div
                            style={{
                                background: "rgba(0, 131, 133, 0.25)",
                                // padding: "10px",
                                textAlign: "center",
                                fontSize: "20px",
                                color: '#008385',
                                // fontFamily:"Lato",
                                fontWeight:"400",
                                height:"44px",
                                display:"flex",
                                alignItems:"center",
                                justifyContent:screens.md?"center":"start",
                                paddingLeft:"8px"
                                // opacity:"25%"
                            }}
                        >
                            Preferred time:
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: 20 ,flexDirection:screens.md?"row":"column",alignItems:"start",padding:"0px 20px" }}>
                            <div className="antDesignDatepaddingRemove" style={{ padding: "0px ", marginRight:4 }}>
                                <Select
                                    defaultValue={currentMonthValue}
                                    style={{ width: 90, border: 0,textAlign:"left" }}
                                    onSelect={handleSelect}
                                    className="antDesignDatepaddingRemove"
                                >
                                    {months.map((month) => (
                                        <Option key={month.value} value={month.value}>
                                            {month.label}
                                        </Option>
                                    ))}
                                </Select>
                            </div>

                            <span  className="antDesignDatepaddingRemove"  style={{textAlign:"left", color:"rgba(74, 74, 74, 1)",
                                // fontFamily:'Lato'
                                }}>
                                Choose the most convenient time slots to check the availability. You can
                                select more than one time slot.
                            </span>
                        </div>

                        <div style={{ marginTop: 20,padding:"0px 20px" }} ref={elementwidthRef}>
                            {selectedSlots && showPreferredTimeSlot && loadingTime == false && Object.keys(showPreferredTimeSlot).length ? Object.keys(showPreferredTimeSlot)?.map((day, index) => (
                                <div style={{ textAlign: 'left' }} >
                                    <div>{`${moment(day).format('ddd D').toUpperCase()} `}</div>
                                    <div style={{ display: "flex", overflowY:"auto",paddingBottom:"6px"}} 
                                    className="my-scroll-container" 
                                     ref={(el) => (elementRefs.current[index] = el) } >
                                        {showPreferredTimeSlot[day].map((slot) => {
                                            return <div
                                                key={slot}
                                                type={selectedSlots.includes(slot) ? "primary" : "default"}
                                                onClick={() => toggleSlot(`${day}${slot.start_time}-${slot.end_time}`, slot, day)}
                                                style={{
                                                    pointerEvents: slot.availablity_status ? 'auto' : 'none',
                                                    minWidth: "83px",
                                                    // width: "auto",   
                                                    color: selectedSlots.includes(`${day}${slot.start_time}-${slot.end_time}`) ? "#008385" : "#000",
                                                    color: slot.availablity_status == 0 ? '#4A4A4A80' : selectedSlots.includes(`${day}${slot.start_time}-${slot.end_time}`) ? "#008385" : "",
                                                    marginTop: 6,
                                                    cursor: 'pointer',
                                                    // padding: '0px 0px',
                                                    paddingRight: '12px',
                                                    // lineHeight: 1
                                                }}
                                            >
                                                {`${slot.start_time}-${slot.end_time}`}
                                            </div>
                                        })
                                        }
                                    </div>
                                    <hr />
                                </div>
                            )) : loadingTime && <Spin className="custom-spinner" />}
                        </div>
                        {selectedSlots && showPreferredTimeSlot && loadingTime == false && Object.keys(showPreferredTimeSlot).length && metaData?.current_page != metaData?.last_page && <Button  onClick={getLoadMoreData} style={{border: "none", width: 182, height: 40,borderRadius:"10px" }}>
                            {/* Load More */}
                            <DownOutlined style={{ color: '#008385' }} />
                        </Button>}
                    </div>
                </Col>
                {selectedSlots.length>0 ? <Col style={{paddingRight:"0px"}}  className="paddingLeft"
                 xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 12 }}
                    lg={{ span: 12 }}
                    xl={{ span: 12 }}
                    xxl={{ span: 12 }}>
                        <div className="widthOfTitle">
                    <div style={{ margin:screens.md?  '20px   auto':'20px  auto', height: 44 }}>
                        <Title style={{ margin: 0, 
                                fontSize: "20px",
                                backgroundColor: 'rgba(0, 131, 133, 0.25)',
                                // fontFamily:"lato",
                                fontWeight:"400",
                                height:"44px",
                                display:"flex",
                                alignItems:"center",
                                color:"#008385",
                                padding:"8px",
                                justifyContent:screens.md?"center":"start" }}><span >Preferred clinic</span>:</Title>
                    </div>
                    <div style={{ maxWidth: screens.md?393:"100vw", margin: 'auto',padding:"0px 15px" }} cl>

                        <div style={{ maxWidth:screens.md? 393:"90vw", margin: 'auto', marginTop: 20 }}>
                            <div onClick={checkLocationPermission}  style={buttonStyle} onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
                                {!isHovered ? <img style={{width:"30px",height:"30px"}} src={locationHover} alt="BigCo Inc. logo"/> : <img  src={location} alt="BigCo Inc. logo"/>}
                                <div >  {locationPermissionData == 'granted' ? "Enabled" : "Enable location"}</div> 
                            </div>
                            <p style={{ textAlign: "center", margin: "10px 0" }}>OR</p>
                            {searchBylocationOption && <Select
                                showSearch
                                placeholder="Select a location"
                                style={{ width: '100%',backgroundColor:"rgba(0, 131, 133, 0.25)",borderRadius:"10px" }}
                                onChange={(value) => onSelectLocation(value)}
                                onSearch={(value) => setsearchBylocationName(value)}
                                options={searchBylocationOption ?? []}
                                filterOption={false}
                                loading={loadingLocation}
                                suffixIcon={null}
                            />}
                            <p style={{ marginTop: 15 }}>You can select up to 3 clinics</p>
                            <hr style={{margin:'3px'}} />
                            
                
                            {/* {selectedClinics.length==0 ?messageApi.error({ type: 'error', content: 'Clinics not available for selected slots.' }):""} */}
                            {selectedClinicsStartAndEndTime && loading == false && selectedClinicsStartAndEndTime.length && selectedClinicsNew && props.data?.allClinicData.data ?
                                selectedClinicsNew
                                    .filter(a => a.status == 1)
                                    .map(a => {
                                        if (a.clinic_id) {
                                            a.id = a.clinic_id;
                                        }
                                        // console.log('selectedClinicsNew a.distance:::', a.distance)
                                        return (
                                            <>
                                                <div style={{ display: "flex", flexWrap: 'wrap', justifyContent: 'space-between', textAlign: 'left', paddingLeft: "15px" }}>
                                                    <div style={{ flex: '1 1 50%' }}>
                                                        <span>{a.name}</span>
                                                    </div>
                                                    <div style={{ flex: '1 1 0%' }}>
                                                        {a.distance && <span>{a.distance}</span>}
                                                    </div>
                                                    <div style={{
                                                        flex: '1 1 20%',
                                                        textAlign: 'right',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'flex-end'
                                                    }}>
                                                        <Checkbox
                                                            className="checkboxSelect"
                                                            checked={selectedClinics.includes(a.id.toString())}
                                                            value={a.id.toString()}
                                                            onClick={handleClinicChange}
                                                            style={{ marginRight: '15px' }}
                                                        />
                                                    </div>
                                                </div>
                                                <hr />
                                            </>
                                        );
                                    })
                                : loading == true ? <Spin className="custom-spinner" /> : ''}
                        </div>
                    </div>
                        </div>
                </Col>:""}
            </Row>
           {buttonActive && (<Button
                        shape="square"
                        icon={<ArrowLeftOutlined style={{ color: '#008385', fontSize: '18px' }} />}
                        style={{
                            backgroundColor: '#C8E6E6', // Light teal
                            border: 'none',
                            width: '40px',
                            height: '40px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginTop: 0,
                            marginRight: 10,
                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                            // position:"absolute",
                            left:"10px"
                        }}
                        onClick={() => props.goback()}
                    />)}
        </div>
        </>
    );
};


export default PreferredTime;
